module.exports = "/_next/static/images/how-it-works-a40ba9ecde3765f59db436b6cfbe18b9.jpg";